<template>
  <div class="withdrawresult">
    <div class="content">
      <img src="../../../assets/image/bs-2.0/success.png" alt="" v-if="flag == 'success'">
      <img src="../../../assets/image/bs-2.0/fail.png" alt="" v-else>
      <p class="text_">提现申请成功</p>
      <p class="tip_">平台将依照积分规则进行发放，请留意您的银行账户</p>
    </div>
    <div class="back_" @click="backHome">
      返回首页
    </div>
  </div>
</template>
<script>
import api from '@/utils/api'
export default {
  data () {
    return {
      successImg: require('../../../assets/image/bs-2.0/success.png'),
      failImg: require('../../../assets/image/bs-2.0/fail.png'),
      flag: ''
    }
  },
  created () {
    this.flag = this.$route.query.flag
    const title = this.flag === 'success' ? '保思商城-提现成功' : '保司商城-提现失败'
    if (document) {
      document.title = title
    }
  },
  methods: {
    backHome () {
      let origin = 'http://wx.run4wd.com'
      if (/ssish/.test(location.href) || /yutai365/.test(location.href)) {
        origin = 'http://wx.ssish.com'
      }
      window.location.href = `${origin}/my/personalCenter/personalCenter`
    }
  }
}
</script>
<style lang="scss" scoped>
.withdrawresult {
  position: relative;
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100%;
  padding: 0 22px;
  .content{
    padding-top: 80px;
  }
  img {
    width: 83px;
    height: 83px;
  }
  .text_ {
    font-size: 14px;
    color: #333;
    margin-top: 19px;
  }
  .tip_ {
    color: #ccc;
    font-size: 12px;
    margin-top: 10px;
  }
  .back_ {
    position: absolute;
    left: 50%;
    bottom: 34px;
    transform: translateX(-50%);
    background: #EAEAEA;
    height: 45px;
    line-height: 45px;
    border-radius: 7px;
    font-size: 15px;
    color: #666;
    font-weight: 500;
    width: 90%;
  }
}
</style>
